import http from '@/plugin/axios'
import Form from '@utils/form'
import HeadInfo from '@/components/common/head-info/head-info.vue'
import Options from '@utils/common/options'
import { $t } from '@/plugin/i18n'
import { formatDate } from '@utils/common/index'
import TableSelect from '@utils/table-select'
import Table from '@utils/table'
import Operation from '@utils/common/operation'
import Jurisdiction from '@utils/jurisdiction'
import Dialog from '@utils/common/dialog'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'

async function getData(vm: any) {
  const { purchaseNo, purchaseSeq, purchasePhaseSeq } = vm.$route.query
  const data = await http<any>({
    url: '/srmPurchaseHead/getPurchaseHeadByNo',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo: purchaseNo }
  })
  const body = await http({
    url: '/srmPurchaseSchedule/getSrmPurchaseBySeq',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo, purchaseSeq, purchasePhaseSeq }
  })

  const list = await http({
    url: '/srmResponseRecord/getSrmResponseRecordList',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNo, purchaseSeq, purchasePhaseSeq }
  })
  vm.setData({ head: { data, body }, list })
  vm.createForm()
}

function getVal(pre: string, prop: string) {
  return (data: any) => data[pre][prop]
}
const info = [
  {
    title: 'customerInformation',
    width: '25%',
    list: [
      ['purOfficeName', getVal('data', 'purOfficeName')],
      ['addressStr', getVal('data', 'addressStr')],
      ['contacts', getVal('data', 'contacts')],
      ['contactPhone', getVal('data', 'contactPhone')]
    ]
  },
  {
    title: 'documentInformation',
    width: '25%',
    list: [
      ['orderType', (data: any) => $t(Options.lib.get('orderType').exec(data.data['orderType']))],
      ['employeeName', getVal('data', 'employeeName')],
      ['purchaseDate', getVal('data', 'purchaseDate')],
      ['remarks', getVal('data', 'remarks')],
      ['dataSource', (data: any) => $t(Options.lib.get('dataSource1').exec(data.data['dataSource']))],
      ['outPurchaseNo', getVal('data', 'outPurchaseNo')]
    ]
  },
  {
    title: 'paymentInformation',
    width: '25%',
    list: [
      ['taxInfo', getVal('data', 'taxInfo')],
      ['txTermsName', getVal('data', 'txTermsName')],
      ['payTermsName', getVal('data', 'payTermsName')],
      ['totalAmountPreTaxPur', getVal('data', 'totalAmountPreTaxPur')],
      ['totalPurAmount', getVal('data', 'totalPurAmount')],
      ['totalTaxIncludedPur', getVal('data', 'totalTaxIncludedPur')]
    ]
  },
  {
    title: 'bodyInformation',
    width: '25%',
    list: [
      ['purchaseSeqAndPurchasePhaseSeq', (data: any) => `${data.body.purchaseSeq}-${data.body.purchasePhaseSeq}`],
      ['goodsNo', getVal('body', 'goodsNo')],
      ['goodsName', getVal('body', 'goodsName')],
      ['spec', getVal('body', 'spec')],
      ['batchPurQty', getVal('body', 'batchPurQty')],
      ['replyDeliveryNum', getVal('body', 'replyDeliveryNum')],
      ['headExpectedArrivalDate', (data: any) => formatDate(data.body.expectedArrivalDate, 'yyyy-MM-dd')]
    ]
  }
]

const header = {
  props: ['data'],
  render(this: any, h: any) { return h('div', [`${this.$t('orderpurchase.ordertrack.purchaseNo')}: ${this.data.head.data.purchaseNo}`]) }
}

function validSupReplyQty(this: any, rules: any, value: number, callback: any) {
  if (value > 0) {
    return callback()
  }
  callback(new Error(this.$t('ordersupplier.ordertrack.requirdSupReplyQty')))
}
const table = new Table('ordersupplier.ordertrack')
  .edit(true)
  .sortable(false)
  .type('index')
  .add('supReplyQty').editor('el-input-number').attrs({ controlsPosition: 'right', min: 0, stepStrictly: true }).rules([{ validator: validSupReplyQty, trigger: 'blur' }])
  .add('supReplyDate').editor('el-date-picker').attrs({ valueFormat: 'yyyy-MM-dd' }).rules([{ required: true, message: 'ordersupplier.ordertrack.requiredAdddate', trigger: 'change' }])
  .add('supReplyRemark').editor()

function remove(this: any, row: any, index: number) {
  const value = [...this.value]
  value.splice(index, 1)
  this.$emit('input', value)
}

const operation = new Operation()
  .add('release').label('common.remove').handle(remove)

const dialogTable = new Table('orderpurchase.ordertrack')
  .type('index')
  .sortable(false)
  .add('operationUser')
  .add('operation')
  .add('adddate').date()
  .add('rejectReason')

function dialogTableApi(data: any) {
  return http({
    url: '/srmResponseRecord/getOperationPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data
  })
}

const dialog = new Dialog('orderpurchase.ordertrack')
  .title('approvalRecord')
  .isfooter(false)
  .table(dialogTable, {
    api: dialogTableApi,
    params: (row: any) => ({ purchaseNo: row.purchaseNo, purchasePhaseSeq: row.purchasePhaseSeq, purchaseSeq: row.purchaseSeq })
  })

function approvalRecord(this: any) {
  dialog.open({ attrs: { row: this.data.head.body }})
}

const jurisdiction = new Jurisdiction('ordersupplier.ordertrack')
  .lib('add').emit('add')
  .add('record').icon('icon-history').handle(approvalRecord)
  .add('tes').text(function(this: any) {
    return this.data.head.body.responseStatusName
  })

const tableSelect = new TableSelect('ordersupplier.ordertrack')
  .type('none')
  .title('tableTitle')
  .jurisdiction(jurisdiction)
  .table(table)
  .operation(operation)
  .filter(() => [{ supReplyQty: undefined, supReplyDate: '', supReplyRemark: '' }])

async function submit(this: any, data: any) {
  const list = data.list || []
  const body = data.head.body
  const expectedArrivalDate = new Date(formatDate(body.expectedArrivalDate, 'yyyy-MM-dd')).getTime()
  const overTime = list.filter((item: any) => {
    const supReplyDate = new Date(item.supReplyDate).getTime()
    return supReplyDate > expectedArrivalDate
  })
  if (overTime.length) {
    await this.$confirm(this.$t('ordersupplier.ordertrack.overTimeTip'), this.$t('ordersupplier.ordertrack.overTimeTitle'))
    await http({
      url: '/srmResponseRecord/saveSrmResponseRecordBatch',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {
        goodsName: body.goodsName,
        goodsNo: body.goodsNo,
        overdueSign: 'Y',
        purchaseNo: body.purchaseNo,
        purchasePhaseSeq: body.purchasePhaseSeq,
        purchaseSeq: body.purchaseSeq,
        records: list.map((item: any) => ({ ...item, supReplyDate: new Date(item.supReplyDate).getTime() }))
      }
    })
  } else {
    await http({
      url: '/srmResponseRecord/saveSrmResponseRecordBatch',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {
        goodsName: body.goodsName,
        goodsNo: body.goodsNo,
        overdueSign: 'N',
        purchaseNo: body.purchaseNo,
        purchasePhaseSeq: body.purchasePhaseSeq,
        purchaseSeq: body.purchaseSeq,
        records: list.map((item: any) => ({ ...item, supReplyDate: new Date(item.supReplyDate).getTime() }))
      }
    })
  }
}

function validSum(this: any, rules: any, value: any[], callback: any) {
  const sum = value.map(i => i.supReplyQty).reduce((a, b) => {
    return a + b
  })
  if (sum <= this.data.head.body.batchPurQty) {
    return callback()
  }
  callback(new Error(this.$t('ordersupplier.ordertrack.maxSum')))
}

const fileNoAttrs = {
  url: '/srmOrderFile/uploadSrmOrderFile',
  baseURL: process.env.VUE_APP_PURCHASE_API,
  getData(this: any) {
    return { docNo: this.$route.query.purchaseNo, fileType: 'purchaseFile' }
  },
  async onSuccess(this: any, res: any, file: any, fileList: any[]) {
    const list = await http<any[]>({
      url: '/srmOrderFile/getSrmOrderFileList',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { docNo: this.$route.query.purchaseNo }
    })
    fileList.forEach((item, index) => {
      const map = list[index]
      if (map) {
        item.name = map.fileName
        item.url = '/srmOrderFile/downloadSrmOrderFile'
        item.baseURL = process.env.VUE_APP_PURCHASE_API
        item.fileId = map.fileId
        item.docNo = map.docNo
      }
    })
  },
  async parse(this: any) {
    const list = await http<any[]>({
      url: '/srmOrderFile/getSrmOrderFileList',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { docNo: this.$route.query.purchaseNo }
    })
    return list.map(item => {
      return {
        name: item.fileName,
        url: '/srmOrderFile/downloadSrmOrderFile',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { fileId: item.fileId, purchaseNo: this.$route.query.purchaseNo },
        fileId: item.fileId,
        docNo: item.docNo
      }
    })
  },
  async beforeRemove(file: any) {
    await http({
      url: '/srmOrderFile/deleteSrmOrderFile',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { fileId: file.fileId, docNo: file.docNo }
    })
  }
}

export default new Form('ordersupplier.ordertrack')
  .dataUrl(getData)
  .url(submit)
  .title(header)
  .formItemComponent('head', HeadInfo).bind('prefix', 'ordersupplier.ordertrack').bind('info', info)
  .add('fileNo').component(UploadSelect).col(24).attrs(fileNoAttrs)
  .table('list', tableSelect).listRequired().rules({ validator: validSum })
  .end()
